import { type ReactElement } from 'react';
import PageShell, { PageSection } from '../components/PageShell';

export default function Karriere(): ReactElement {
  return (
    <PageShell
      title="Karriere"
      intro="Wir bauen die Buchhaltung von morgen – und suchen Menschen, die das mit uns gestalten wollen."
    >
      <PageSection title="Arbeiten bei Saldify">
        <p>
          Als kleines, fokussiertes Team legen wir Wert auf Eigenverantwortung,
          kurze Wege und echte Wirkung. Wir entwickeln ein Produkt, das tausende
          Selbstständige im Alltag entlastet – mit modernem Tech-Stack und hohem
          Qualitätsanspruch.
        </p>
      </PageSection>

      <PageSection title="Aktuelle Stellen">
        <p>
          Derzeit haben wir keine offenen Stellen ausgeschrieben. Initiativ­bewerbungen
          sind aber jederzeit willkommen: Schreiben Sie uns, was Sie begeistert und
          wie Sie Saldify voranbringen würden – an{' '}
          <a href="mailto:info@saldify.de" className="text-primary-600 hover:underline">
            info@saldify.de
          </a>
          .
        </p>
      </PageSection>
    </PageShell>
  );
}
